import * as Sentry from '@sentry/react'
import { defaultBeforeSend } from './filters'

export interface InitSentryOptions {
  dsn: string | undefined
  app: 'admin' | 'platform' | 'academy' | 'ingestion' | (string & {})
  environment: string
  release?: string
  /** Override beforeSend if you need app-specific filtering. */
  beforeSend?: Sentry.BrowserOptions['beforeSend']
  /** 0.0–1.0 traces sample rate. Default 0.1 in prod, 1.0 elsewhere. */
  tracesSampleRate?: number
}

/**
 * Boot Sentry for an L3 app. Safe to call with an empty DSN (e.g. in dev) —
 * Sentry initializes as a no-op and never posts events.
 */
export function initSentry(opts: InitSentryOptions): void {
  if (!opts.dsn) {
    console.info('[observability] Sentry DSN not provided — skipping init')
    return
  }

  Sentry.init({
    dsn: opts.dsn,
    environment: opts.environment,
    release: opts.release,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate:
      opts.tracesSampleRate ??
      (opts.environment === 'production' ? 0.1 : 1.0),
    beforeSend: opts.beforeSend ?? defaultBeforeSend,
    initialScope: {
      tags: { app: opts.app },
    },
  })
}
